/**
 * Boilerplate entry — LPR phase 1.
 */
import '../css/tailwind-base.css';
import '../scss/main.scss';
import '../css/tailwind-utilities.css';

import { ready, qsa } from './core/dom.js';
import { initHashScroll } from './modules/hash-scroll.js';
import { initLprSite } from './modules/lpr-site.js';
import { initLprHero } from './modules/lpr-hero.js';
import { initReveal } from './modules/reveal.js';
import { initForms } from './modules/form.js';
import { initWordPress } from './modules/wordpress.js';
import { initAnalyticsGtag } from './modules/analytics-gtag.js';

ready(() => {
	qsa('[data-year]').forEach((el) => {
		el.textContent = String(new Date().getFullYear());
	});

	initHashScroll();
	initLprSite();
	initLprHero();
	initReveal();
	initForms();
	initWordPress();
	initAnalyticsGtag();
});
